module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Opret faste tillæg")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "create-form__grid"
  }, [_c('div', {
    staticClass: "d-input-group cf-tillaeg"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
    ref: "tillaegSelect",
    attrs: {
      "items": _vm.salaryCodesForDSelect,
      "multiple": false,
      "placeholder": 'Vælg tillæg',
      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectTillaeg,
      "remove": function($event) {
        return _vm.onSelectTillaeg(null)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-antal"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Enheder pr. måned *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.antal),
      expression: "antal"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "Indtast antal"
    },
    domProps: {
      "value": (_vm.antal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.antal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-start"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Startdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.startDato,
      "width100": true
    },
    on: {
      "changed": function($event) {
        _vm.startDato = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-slut"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Slutdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.endDato,
      "width100": true
    },
    on: {
      "changed": function($event) {
        _vm.endDato = $event
      }
    }
  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312
      }),
      expression: "{\n                  arrow: true,\n                    placement : 'top',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting,
      'do-bttn--submit--disabled': !_vm.isValid
    },
    attrs: {
      "disabled": !_vm.isValid || _vm.isSubmitting,
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23b9a224!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/SdCreateFastTillaeg.vue
// module id = 1804
// module chunks = 1